import { useState, useEffect } from 'react';
import recordEvent from '@department-of-veterans-affairs/platform-monitoring/record-event';
import RepresentativeStatusApi from '../api/RepresentativeStatusApi';
import { formatContactInfo } from '../utilities/formatContactInfo';

export function useRepresentativeStatus(
  userHasPOAAccess = true,
  pageName = 'profile',
) {
  const [representative, setRepresentative] = useState(null);
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchRepStatus = async () => {
      if (userHasPOAAccess) {
        setIsLoading(true);
        setError(null);

        try {
          const response =
            await RepresentativeStatusApi.getRepresentativeStatus();

          let apiName = 'fetch-rep-status';

          if (response?.data?.id) {
            const poaData = response.data;

            const { concatAddress, contact, extension, vcfUrl } =
              await formatContactInfo(poaData.attributes);

            const poaType =
              poaData.attributes.individualType || poaData.attributes.type;

            apiName += `-${poaType}`;

            setRepresentative({
              id: poaData.id,
              poaType,
              ...poaData.attributes,
              concatAddress,
              contact,
              extension,
              vcfUrl,
            });
          }

          recordEvent({
            event: 'api_call',
            'api-name': apiName,
            'api-latency-ms': response?.meta?.resultTime,
            'api-status': 'success',
            'error-key': undefined,
            version: pageName,
          });
        } catch (e) {
          setError(e.message);
          recordEvent({
            event: 'api_call',
            'api-name': 'fetch-rep-status-error',
            'api-latency-ms': undefined,
            'api-status': 'fail',
            'error-key': e.message,
            version: pageName,
          });
        } finally {
          setIsLoading(false);
        }
      }
    };

    fetchRepStatus();
  }, [userHasPOAAccess, pageName]);

  return { representative, isLoading, error };
}
